module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-teal-462db950195527dd55d340e6f5c0ed31.svg";